import whiteMeshHat from "../assets/white-mesh-wwg-hat.png";
import blackMeshHat from "../assets/black-mesh-wwg-hat.png";
import longSleeve from "../assets/wwg-long-sleeve.png";
import flatBrimHat from "../assets/flat-brim-wwg-hat.png";
import lawsGrowth from "../assets/15-laws-growth.png";
import dreamDoer from "../assets/dream-doer.png";
import languageOfTrust from "../assets/language-of-trust.png";
import clearBackpack from "../assets/clear-backpack.png";
import businessOverview from "../assets/business-overview.png";
import buildLifeHat from "../assets/build-your-life-hat.png";

// !!!ENABLE THE MOCK DATA BY RUNNING THE FOLLOWING COMMAND IN THE WEB CONSOLE
// localStorage.setItem("wwgStoreUseMockStockData", "true")
// DISABLE WITH localStorage.removeItem("wwgStoreUseMockStockData")

export const enhancedStockInfo = [
  {
    imageUrl: whiteMeshHat,
    stockId: "1",
    title: "Mock Data Enabled",
    memberPrice: 19.95,
    retailPrice: 24.0,
    itemType: "CONFIGURABLE",
    hasColorChoices: true,
    isHot: true,
    isNew: true,

    images: [
      { src: whiteMeshHat, label: "Blue" },
      { src: whiteMeshHat, label: "White" },
      { src: whiteMeshHat, label: "Teal" },
      { src: whiteMeshHat, label: "Grey" },
    ],
    // Lorem ipsum placeholder images so the gallery has multiple photos to
    // preview (main image fill + thumbnail strip wrapping).
    productImages: [
      { assetId: 1, url: "https://picsum.photos/seed/wwg1/264/264" },
      { assetId: 2, url: "https://picsum.photos/seed/wwg2/264/264" },
      { assetId: 3, url: "https://picsum.photos/seed/wwg3/264/264" },
      { assetId: 4, url: "https://picsum.photos/seed/wwg4/264/264" },
      { assetId: 5, url: "https://picsum.photos/seed/wwg5/264/264" },
    ],
    defaultSize: "One size fits all",
    defaultColor: "White w/black",
    description:
      "This is a description of the item shown above, the hat is white with a light blue WWG Logo.",
    category: "Merch",
    releasedDate: "02.04.2023",
    sku: "HAT-WWG-WHT",
    details: {},
    is3rdParty: true,
  },
  {
    imageUrl: blackMeshHat,
    stockId: "2",
    title: "Black Mesh WWG Hat",
    memberPrice: 19.95,
    retailPrice: 24.0,
    itemType: "CONFIGURABLE",
    hasColorChoices: true,
    isHot: false,
    isNew: true,
    images: [
      { src: blackMeshHat, label: "Blue" },
      { src: blackMeshHat, label: "White" },
      { src: blackMeshHat, label: "Teal" },
      { src: blackMeshHat, label: "Grey" },
    ],
    defaultSize: "One size fits all",
    defaultColor: "Black w/white",
    description: "Classic mesh hat in black with WWG logo.",
    category: "Merch",
    releasedDate: "02.04.2023",
    sku: "HAT-WWG-BLK",
    details: {},
  },
  {
    imageUrl: longSleeve,
    stockId: "3",
    title: "WWG Long Sleeve",
    memberPrice: 19.95,
    retailPrice: 28.0,
    itemType: "CONFIGURABLE",
    hasColorChoices: true,
    isHot: true,
    isNew: false,

    images: [
      { src: longSleeve, label: "Blue/Teal" },
      { src: longSleeve, label: "White/Black" },
      { src: longSleeve, label: "Grey/Black" },
      { src: longSleeve, label: "Blue/Grey" },
    ],
    defaultSize: "M",
    defaultColor: "Blue w/Teal",
    description: "Comfort long sleeve with WWG logo.",
    category: "Apparel",
    releasedDate: "02.04.2023",
    sku: "LS-WWG-001",
    details: {},
    sizeOptions: [
      { label: "S", isSoldOut: false },
      { label: "M", isSoldOut: false },
      { label: "L", isSoldOut: false },
      { label: "XL", isSoldOut: false },
      { label: "2X", isSoldOut: false },
      { label: "3X", isSoldOut: true },
    ],
  },
  {
    imageUrl: flatBrimHat,
    thumbUrl: flatBrimHat,
    stockId: "4",
    title: "Flat-brim WWG Hat",

    memberPrice: 19.95,
    retailPrice: 24.0,
    itemType: "STANDARD",
    isUnavailable: true,
    description: "Flat-brim style WWG hat.",
    category: "Merch",
    releasedDate: "02.04.2023",
    sku: "HAT-WWG-FLAT",
    details: {},
    // Mocks the new productImages field (func-bsm-api SingleStockGet spec):
    // all active full-size assets for the product, click-through gallery.
    productImages: [
      { assetId: 1, url: flatBrimHat, sortOrder: 0 },
      { assetId: 2, url: buildLifeHat, sortOrder: 1 },
    ],
  },
  {
    imageUrl: lawsGrowth,
    stockId: "5",
    title: "15 Invaluable Laws of Growth",
    author: "John C Maxwell",
    memberPrice: 19.95,
    retailPrice: 24.0,
    itemType: "STANDARD",
    isHot: false,
    isNew: false,
    description: "Proven principles to help you reach your potential.",
    category: "Self Improvement",
    releasedDate: "12.18.2014",
    sku: "BK-1187",
    details: {
      pageNum: "336",
      publisher: "Touchstone",
      publishedDate: "August 26, 1987",
      suggestedRetail: "15.99",
    },
  },
  {
    imageUrl: dreamDoer,
    stockId: "6",
    title: "Dream Doer",
    author: "Paul E. Tsika",
    memberPrice: 19.95,
    retailPrice: 24.0,
    itemType: "STANDARD",
    isHot: false,
    isNew: false,
    isPreOrder: true,
    description: "Inspiration for turning dreams into action.",
    category: "Motivational",
    releasedDate: "01.13.2023",
    sku: "BK-DRM-001",
    details: {},
  },
  {
    imageUrl: languageOfTrust,
    stockId: "7",
    title: "The Language of Trust",
    author: "Michael Maslansky",
    memberPrice: 15.55,
    retailPrice: 21.0,
    itemType: "STANDARD",
    isHot: true,
    isNew: true,
    description: "Communicate to build credibility and trust.",
    category: "Business",
    releasedDate: "10.02.2010",
    sku: "BK-TRUST-01",
    details: {},
  },
  {
    imageUrl: clearBackpack,
    stockId: "8",
    title: "Clear Backpack",
    subTitle: "Comes with a Bag Tag!",
    memberPrice: 22.95,
    retailPrice: 29.0,
    itemType: "STANDARD",
    isNew: true,
    description: "Stadium compliant clear backpack.",
    category: "Accessories",
    releasedDate: "02.01.2023",
    sku: "BAG-CLR-01",
    details: {},
  },
  {
    imageUrl: businessOverview,
    stockId: "9",
    title: "Business Overview",
    subTitle: "Pack of 25",
    memberPrice: 4.5,
    retailPrice: 6.0,
    itemType: "BUNDLE",
    isHot: true,
    description: "Overview handouts (pack of 25).",
    category: "Print",
    releasedDate: "01.15.2023",
    sku: "PRINT-OVERVIEW-25",
    details: {},
  },
  {
    imageUrl: buildLifeHat,
    stockId: "10",
    title: "Build Your Life® Hat",
    memberPrice: 23.99,
    retailPrice: 29.0,
    itemType: "CONFIGURABLE",
    hasColorChoices: true,
    colorOptions: ["#243746", "#FFFFFF"],
    images: [
      { src: buildLifeHat, label: "Blue" },
      { src: buildLifeHat, label: "White" },
    ],
    defaultSize: "One size fits all",
    defaultColor: "Blue",
    description: "Build Your Life® embroidered hat.",
    category: "Merch",
    releasedDate: "03.10.2023",
    sku: "HAT-BYL-01",
    details: {},
  },
];
